<template>
  <div
    v-if="isNewApricot"
    class="pt-3 trustpilot-widget-container"
  >
    <trustpilot-widget-template
      v-show="isWidgetVisible && $vuetify.breakpoint.width < 768"
      ref="trustboxMobile"
      class="mx-auto my-0 trustpilot-widget"
      theme="light"
      template-id="5419b637fa0340045cd0c936"
    />
    <trustpilot-widget-template
      v-show="isWidgetVisible && $vuetify.breakpoint.width >= 768"
      ref="trustboxDesktop"
      class="trustpilot-widget"
      theme="light"
      template-id="5419b6ffb0d04a076446a9af"
    />
  </div>
</template>

<script>
import TrustpilotWidgetTemplate from '@/components/TrustpilotWidget/TrustpilotWidgetTemplate.vue';

export default {
  name: 'trustpilot-widget',
  components: {
    TrustpilotWidgetTemplate,
  },
  inject: [
    'constants',
    'config',
  ],
  data () {
    return {
      isWidgetVisible: false,
    };
  },
  computed: {
    isNewApricot () {
      return this.constants.PARTNERS.NewApricot.includes(this.config.partner);
    },
  },
  methods: {
    loadTrustPilotWidget () {
      const widgetUrl = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      const existingScript = document.querySelector(`script[src="${widgetUrl}"]`);

      if (existingScript) {
        this.isWidgetVisible = true;
        this.triggerTrustPilot();
        return;
      }

      const script = document.createElement('script');
      script.src = widgetUrl;
      script.async = true;
      script.onload = () => {
        this.isWidgetVisible = true;
        this.triggerTrustPilot();
      };
      document.head.appendChild(script);
    },
    triggerTrustPilot () {
      const widgets = [
        this.$refs.trustboxMobile,
        this.$refs.trustboxDesktop,
      ];

      widgets.forEach(widget => {
        if (widget && widget.$el) {
          window.Trustpilot.loadFromElement(widget.$el);
        }
      });
    },
  },
  mounted () {
    this.loadTrustPilotWidget();
  },
};
</script>

<style lang="scss">
.trustpilot-widget-container {
  background-color: $clr-white;
  position: relative;
  z-index: 1;
}
</style>
